import styled from 'styled-components';

export const SearchForm = styled.div`
  background-color: var(--nightBlue);

  form {
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;

    label {
      cursor: pointer;
      img {
        width: 1.25rem;
        margin-top: 0.25rem;
      }
    }
    .search-field {
      display: flex;
      align-items: center;
      padding: 0 0 0 0.75rem;
      background-color: var(--white);
      border-top-left-radius: 4rem;
      border-bottom-left-radius: 4rem;
      width: 60%;
      input[type='text'] {
        width: 100%;
        font-size: 1rem;
        color: var(--nightBlue);
        border: none;
        padding: 0 1rem 0 0.5rem;
        height: 2.5rem;
        &:focus {
          outline: none;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    form .search-field {
      width: 50%;
    }
  }
`;

export const SearchBtn = styled.button`
  height: 2.5rem;
  border: none;
  border-top-right-radius: 4rem;
  border-bottom-right-radius: 4rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: var(--white);
  min-width: auto;
  background-image: linear-gradient(var(--gradient));

  cursor: pointer;
`;
